@if(rentalCustomerType){
<div style="position: absolute; right: 0; top: 0;">
  @if(rentalCustomerType == 'Consumer') {
  <button matTooltip="{{ 'turbo.core.RentalDialog.tipConsumer' | translate : 'Person'}}" mat-raised-button color="primary" style="border-radius: 0 0 4px 4px;"><mat-icon>person</mat-icon></button>
  }
  @if(rentalCustomerType == 'Company') {
  <button matTooltip="{{ 'turbo.core.RentalDialog.tipCompany' | translate : 'Company'}}" mat-raised-button color="primary" style="border-radius: 0 0 4px 4px;"><mat-icon>apartment</mat-icon></button>
  }
</div>
}
@else {
<div style="position: absolute; right: 0; top: 0;">
  @if(customer.Type == customerType.Consumer) {
  <button matTooltip="{{ 'turbo.core.RentalDialog.tipConsumer' | translate : 'Person'}}" mat-raised-button color="primary" style="border-radius: 0 0 4px 4px;"><mat-icon>person</mat-icon></button>
  }
  @if(customer.Type == customerType.Consumer) {
  <button matTooltip="{{ 'turbo.core.RentalDialog.tipCompany' | translate : 'Company'}}" mat-flat-button (click)="changeCustomerType(customerType.Company)" style="border-radius: 0 0 4px 4px;"><mat-icon>apartment</mat-icon></button>
  }
  @if(customer.Type == customerType.Company) {
  <button matTooltip="{{ 'turbo.core.RentalDialog.tipConsumer' | translate : 'Person'}}" mat-flat-button (click)="changeCustomerType(customerType.Consumer)" style="border-radius: 0 0 4px 4px;"><mat-icon>person</mat-icon></button>
  }
  @if(customer.Type == customerType.Company) {
  <button matTooltip="{{ 'turbo.core.RentalDialog.tipCompany' | translate : 'Company'}}" mat-raised-button color="primary" style="border-radius: 0 0 4px 4px;"><mat-icon>apartment</mat-icon></button>
  }
</div>
}
<customer-form-component #frm [customer]="customer" [clientSettingsForm]="clientSettingsForm" (valueChanged)="valueChanged.emit($event)">
</customer-form-component>
@if(isLoading) {
<div style=" text-align: center; margin: -40px 0 0 -15px; position: absolute; width: 100%; height: 100%; background: rgba(255,255,255,0.8); padding: 100px;">
  <mat-spinner mode="indeterminate" style="margin: auto"></mat-spinner>
  <br />
  <h2>{{ 'turbo.Customers.CustomerInfo.msgLoading' | translate : 'Loading customer information...'}}</h2>
</div>
}
